export const SIZES = [
	{ name: 'xs', range: [0, 600] },
	{ name: 'sm', range: [600, 960] },
	{ name: 'md', range: [960, 1264] },
	{ name: 'lg', range: [1264, 1904] },
	{ name: 'xl', range: [1904, Infinity] },
];
